import history from '../history';
import { buildDispatchable } from '../actions/_action-utilities';
import { featureSelection, getDetail, detailToggleArtifacts, setActiveProcess, featureActivation, importToAmplify, setActiveNote } from '../actions/cases.action';
import { caseEditsActions } from '../actions/case-edits';
import { openWindow, setBackToWorklistPath } from '../actions/ui';
import { codeBenchActions, appServiceLines } from '@codametrix/ui-common';
const { toServiceLineSlug, normalizeServiceLineName } = appServiceLines;
export const mapStateToProps = function(state) {
    const { cases, ui, caseEdits, capabilities, processInstance, accountSettings } = state;
    const demographicsPanelLocation = accountSettings?.accountDefaults?.formObject?.demographicsPanelLocation || 'right';
    const demographicsPanelVisibility = accountSettings?.accountDefaults?.formObject?.demographicsPanelVisibility || 'open';
    return {
        ...cases,
        processInstance,
        capabilities,
        propertyConfig: ui.propertyConfig,
        caseEdits: caseEdits.caseEdits,
        tenantId: ui.context.activeContext?.tenantId,
        hasAmplifyCaseRunV2Access: ui.hasAmplifyCaseRunV2Access,
        demographicsPanelLocation,
        demographicsPanelVisibility,
        caseAccessState: state.codeBench?.caseAccessState ?? ''
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onCaseAction: (action)=>{
            runDispatchable(()=>{
                return dispatch(importToAmplify(action));
            });
        },
        openChildWindow: (windowOpenArgs)=>{
            dispatch(openWindow(windowOpenArgs));
        },
        openAmplifyCase: (amplifyLaunchConfig)=>{
            dispatch(setBackToWorklistPath({
                path: 'worklist/'
            }));
            const sl = toServiceLineSlug(normalizeServiceLineName(String(amplifyLaunchConfig.serviceLine ?? '')));
            history.push(`/cmx/worklist/${sl}/case/${amplifyLaunchConfig.caseId}/case-run/${amplifyLaunchConfig.id}${amplifyLaunchConfig?.hasAmplifyCaseRunV2Access ? '/v2' : ''}/`);
        },
        toggleArtifacts: (showAll)=>{
            dispatch(detailToggleArtifacts(showAll));
        },
        onNavigate: (caseId, pushAction, serviceLine, tenantId, hasAmplifyCaseRunV2Access)=>{
            if (pushAction) {
                const sl = toServiceLineSlug(normalizeServiceLineName(String(serviceLine ?? '')));
                const targetPath = `/cmx/cases/${sl}/${caseId}/`;
                if (history.location.pathname.replace(/\/$/, '') !== targetPath.replace(/\/$/, '')) {
                    history.push(targetPath);
                }
            }
            return dispatch(getDetail({
                caseId: caseId,
                serviceLine,
                tenantId,
                hasAmplifyCaseRunV2Access
            }));
        },
        onFeatureActivation: (selection)=>{
            dispatch(featureActivation(selection));
        },
        onFeatureSelection: (selection)=>{
            dispatch(featureSelection(selection));
        },
        setActiveProcess: (activeProcessPayload)=>{
            dispatch(setActiveProcess(activeProcessPayload));
        },
        showList: (serviceLine, refreshList)=>{
            runDispatchable(()=>{
                const slug = toServiceLineSlug(normalizeServiceLineName(serviceLine));
                if (refreshList) {
                    history.replace(`/cmx/cases/${slug}/`);
                } else {
                    history.replace(`/cmx/cases/${slug}/?back=true`);
                }
            });
        },
        updateValue: (updatedFieldAndValue)=>{
            dispatch(caseEditsActions.updateValue(updatedFieldAndValue));
        },
        loadAllPatientDetailOptions: async (tenantId, facility)=>{
            await dispatch(caseEditsActions.loadAllPatientDetailOptions({
                activeTenantId: tenantId,
                facility
            }));
        },
        updateCase: (updatesAndInfo)=>{
            dispatch(caseEditsActions.updateCase(updatesAndInfo));
        },
        setActiveNote: (activeNote)=>{
            dispatch(setActiveNote(activeNote));
        },
        hideSideNavBar: ()=>{
            dispatch(codeBenchActions.hideSideNavBar());
        },
        showCoderNotesInfo: (coderNotesParams)=>{
            dispatch(codeBenchActions.navigateCoderNotes(coderNotesParams));
        },
        showPatientInfo: (caseRun)=>{
            dispatch(codeBenchActions.navigatePatient(caseRun));
        }
    };
};
